import { render, staticRenderFns } from "./ChamberNormativeBaseDocuments.vue?vue&type=template&id=7e971465&scoped=true&"
import script from "./ChamberNormativeBaseDocuments.vue?vue&type=script&lang=js&"
export * from "./ChamberNormativeBaseDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ChamberNormativeBaseDocuments.vue?vue&type=style&index=0&id=7e971465&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e971465",
  null
  
)

export default component.exports